import { render, staticRenderFns } from "./leftColCompartirA.vue?vue&type=template&id=60ee42d5"
import script from "./leftColCompartirA.vue?vue&type=script&lang=js"
export * from "./leftColCompartirA.vue?vue&type=script&lang=js"
import style0 from "./leftColCompartirA.vue?vue&type=style&index=0&id=60ee42d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports